import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Button } from "../ui/button";
import { LASERCUT } from "@/constants/testIds";

const LINKS = [
  { slug: "tentang", label: "Tentang" },
  { slug: "proses", label: "Proses" },
  { slug: "katalog", label: "Katalog" },
  { slug: "portofolio", label: "Portofolio" },
  { slug: "kontak", label: "Kontak" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-ink/80 backdrop-blur-xl border-b border-linecol" : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-24 flex items-center justify-between h-20">
        <button
          data-testid={LASERCUT.navbarLogo}
          onClick={() => scrollTo("hero")}
          className="font-heading text-2xl tracking-widest text-chromed"
        >
          LASER<span className="text-brass">CUT</span>
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.slug}
              data-testid={LASERCUT.navLink(l.slug)}
              onClick={() => scrollTo(l.slug)}
              className="text-sm uppercase tracking-[0.15em] text-chromed/70 hover:text-brass transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Button
            data-testid={LASERCUT.navbarCta}
            onClick={() => scrollTo("konsultasi")}
            className="rounded-none bg-brass text-ink hover:bg-brass-light font-medium tracking-wide px-6"
          >
            Konsultasi Custom
          </Button>
        </div>

        <button
          data-testid={LASERCUT.navMobileToggle}
          className="lg:hidden text-chromed"
          onClick={() => setOpen(!open)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="lg:hidden bg-ink border-t border-linecol px-6 py-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <button
              key={l.slug}
              onClick={() => scrollTo(l.slug)}
              className="text-left text-sm uppercase tracking-[0.15em] text-chromed/80"
            >
              {l.label}
            </button>
          ))}
          <Button
            onClick={() => scrollTo("konsultasi")}
            className="rounded-none bg-brass text-ink hover:bg-brass-light w-full"
          >
            Konsultasi Custom
          </Button>
        </motion.div>
      )}
    </header>
  );
};
